import { PhishingLanguagesEnum } from '@/api/enums/phishing-languages.enum';
import {
  CatalogueVariant,
  CatalogueVariantWithLanguage,
  hasVariantLanguage,
} from '@/client/campaigns/types/catalogue.type';
import {
  getPhishingLanguageCode,
  getPhishingLanguageLabel,
} from '@/utils/helpers';
import { Dropdown } from 'primereact/dropdown';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledDropdown = styled(Dropdown)`
  width: 100%;

  &.p-disabled {
    opacity: 1;
  }

  &.read-only .p-dropdown-trigger {
    display: none;
  }
`;

type PlanSimulationLanguageFieldProps =
  | {
      readOnly?: false;
      variants: CatalogueVariant[];
      value?: string;
      onChange: (variant: CatalogueVariantWithLanguage) => void;
    }
  | {
      readOnly: true;
      language: PhishingLanguagesEnum;
    }
  | {
      readOnly: true;
      languages: PhishingLanguagesEnum[];
    };

export const PlanSimulationLanguageField: React.FC<
  PlanSimulationLanguageFieldProps
> = (props) => {
  const { t } = useTranslation();

  const renderDropdown = () => {
    if (props.readOnly) {
      const option =
        'languages' in props
          ? {
              label: props.languages.map(getPhishingLanguageCode).join(', '),
              value: props.languages.join(','),
            }
          : {
              label: getPhishingLanguageLabel(props.language),
              value: props.language,
            };

      return (
        <StyledDropdown
          inputId="plan-simulation-language"
          className="read-only"
          value={option.value}
          options={[option]}
          disabled
        />
      );
    }

    const { value, onChange } = props;
    const variants = props.variants.filter(hasVariantLanguage);

    return (
      <StyledDropdown
        inputId="plan-simulation-language"
        dropdownIcon="pi pi-chevron-down"
        value={value}
        options={variants.map((variant) => ({
          label: getPhishingLanguageLabel(variant.language),
          value: variant.templateId,
        }))}
        onChange={(e) => {
          const variant = variants.find((v) => v.templateId === e.value);
          if (variant) {
            onChange(variant);
          }
        }}
        disabled={variants.length === 1}
      />
    );
  };

  return (
    <div className="field w-full mb-4">
      <label htmlFor="plan-simulation-language">{t('generic.lang')}</label>
      {renderDropdown()}
    </div>
  );
};
